import FormContas from "components/FormContas";

const CriarConta = () => (
  <div className="card">
    <FormContas />
  </div>
);

export default CriarConta;
